import { CONSTANTS } from '@pk/powerkioskutils';
import * as XLSX from '@sheet/core';

import * as _ from 'lodash';

import { AttachmentService } from 'src/app/attachment/attachment.service';
import { environment } from '../../../../environments/environment';
import { ServiceLocator } from '../../service-locator.service';
import { PendingCommission } from '../pending-commission';
import { SupplierCommissionMap } from '../supplier-commission-map';
import { AbstractPreviewReport } from './preview-report-abstract';

export class MappingPreviewReport extends AbstractPreviewReport {
	public canEditSheetMapping = false;
	public suffixLabel = 'Preview';

	public file: File;
	public supplierCommissionMap: SupplierCommissionMap;

	public attachmentService: AttachmentService;

	constructor(file: File, supplierCommissionMap: SupplierCommissionMap) {
		super();
		this.file = file;
		this.supplierCommissionMap = supplierCommissionMap;

		this.attachmentService = ServiceLocator.injector.get(AttachmentService);
	}

	public async setup() {
		if (!this.commissionTypes) {
			this.commissionTypes = (await this.graphqlService.getCommissionTypeListData())?.data?.commissionTypes?.message;
		}
		this.rawData = await this.getRawData();
		const pendingCommissions = await this.getMappedData();
		this.totalSupplierPayment = _.sumBy(pendingCommissions, pc => parseFloat(String(pc.supplierPayment)));
		this.pendingCommissions = _.take(pendingCommissions, 5);
	}

	public async getRawData(): Promise<any[]> {
		const rawData: any[] = await new Promise(async (resolve, reject) => {
			const reader = new FileReader();
			reader.onload = (ev: any) => {
				try {
					const fileResult = new Uint8Array(ev.target.result);
					const workbook = XLSX.read(fileResult, { type: 'array' });
					const defautSheetName = workbook.SheetNames[0];
					const sheetName = (this.supplierCommissionMap?.sheetName ?? '')
						.split(' ')
						.map(p => {
							const res = p.match(/%(\w+)%/);

							if (res && CONSTANTS.regularExpressions.hasOwnProperty(res[1])) {
								return CONSTANTS.regularExpressions[res[1]];
							}

							return p;
						})
						.join(' ');
					const workSheet = this.supplierCommissionMap?.sheetName
						? // eslint-disable-next-line max-len
							(Object.entries(workbook.Sheets).find((k, v) => k[0].search(RegExp(sheetName, 'i')) !== -1)?.[1] ?? workbook.Sheets[defautSheetName])
						: workbook.Sheets[defautSheetName];
					// eslint-disable-next-line @typescript-eslint/naming-convention
					const data = XLSX.utils.sheet_to_csv(workSheet, { FS: '|' });

					resolve(
						this.supplierCommissionMap?.headerRow
							? _.take(data.split('\n').slice(this.supplierCommissionMap?.headerRow - 1), 6)
							: _.take(data.split('\n'), 6),
					);
				} catch (e) {
					reject(e);
				}
			};
			reader.readAsArrayBuffer(this.file);
		});

		return rawData;
	}
	public async getMappedData(): Promise<PendingCommission[]> {
		const fileUploadUrl = `${environment.baseAPIUrl}/pending-commissions/upload`;

		const formData = new FormData();
		formData.append('files', this.file, this.file?.name);
		formData.append('supplierId', this.supplierCommissionMap?.supplierId);
		if (this.supplierCommissionMap?.brandSupplierId) {
			formData.append('brandSupplierId', this.supplierCommissionMap?.brandSupplierId);
		}
		formData.append('isPreview', 'true');
		formData.append('supplierCommissionMapId', String(this.supplierCommissionMap.id));

		const result = await this.attachmentService.uploadCustom(fileUploadUrl, formData);

		if (result && !result.error) {
			return result.message.map(p => new PendingCommission(p));
		} else {
			throw new Error('Error occurred');
		}
	}

	//Don't need an update function for showing previews in Mapping tab
	public async updateSheetMapping(supplierCommissionMapId: number): Promise<void> {
		return;
	}
	public async applySystemGeneratedMapping() {
		return false;
	}
}
